import { Map, Marker, InfoWindow } from 'google-react-maps';
import {getIconForClient} from 'utils';

const ClientRooftopView = (props) => {
  const { client } = props;
  const isGeocoded = client.address.geocoded;

  if (!isGeocoded) {
    return (
      <div className="rooftop-view-placeholder">
        <h1>Client not Geocoded.</h1>
      </div>
    );
  }

  const longitude = client.address.feature.geometry.coordinates[0];
  const latitude = client.address.feature.geometry.coordinates[1];

  return (
    <Map
      api-key="AIzaSyCWuH5SGDikY4OPSrbJxqTi4Y2uTgQUggw"
      optionsConstructor={function(maps) {
        Object.assign(this, {
          zoom : 23,
          mapTypeId : maps.MapTypeId.ROADMAP,
          disableDefaultUI: true,
          zoomControl : true,
          zoomControlOptions : {
            position: maps.ControlPosition.LEFT_CENTER
          },
          keyboardShortcuts : true,
          panControl: true,
          panControlOptions : {
            position : maps.ControlPosition.BOTTOM_RIGHT
          },
          mapTypeId : maps.MapTypeId.HYBRID,
          mapTypeControl : true,
          mapTypeControlOptions : {
            position: maps.ControlPosition.RIGHT_TOP
          },
          fullscreenControlOptions : {
            position: maps.ControlPosition.RIGHT_BOTTOM
          },
          fullscreenControl: true
        });
      }}
      style={{position:"absolute", top: 0, right: 0, left: 0, bottom : 0, width : "100%", height: '300px'}}
    >
      <Marker icon={getIconForClient(client)} coords={{ lng: longitude, lat: latitude }}>
        <InfoWindow open={true}>
            <div>{client.name}</div>
        </InfoWindow>
      </Marker>
    </Map>
  )
}

export default ClientRooftopView;



// WEBPACK FOOTER //
// ./src/browser/components/client/client-rooftop-view.js